<template>
  <div>
    <a-modal
        v-drag-modal
        wrap-class-name="custom-modal-wrap" v-model="localVisible" :confirmLoading="loading" :maskClosable="false" :destroyOnClose="true" @cancel="cancel" @ok="confirm"
>
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
        <div style="max-height: 65vh; overflow-y: auto;border: 1px solid #277fd0 ; overflow-x: hidden;padding: 10px;margin: -10px">
        <a-form-model ref="form" :model="form.others" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" label="名称">
            <a-input v-model="form.others.name" />
          </a-form-model-item>
          <a-form-model-item prop="number" label="编号">
            <a-input v-model="form.others.number" />
          </a-form-model-item>
          <a-form-model-item prop="contact" label="联系人">
            <a-input v-model="form.others.contact" />
          </a-form-model-item>
          <a-form-model-item prop="phone" label="手机号">
            <a-input v-model="form.others.phone" />
          </a-form-model-item>
          <a-form-model-item prop="email" label="邮箱">
            <a-input v-model="form.others.email" />
          </a-form-model-item>
          <a-form-model-item prop="address" label="地址">
            <a-input v-model="form.others.address" />
          </a-form-model-item>
          <a-form-model-item prop="ID_image" label="上传附件">
            <Upload :ID_image="form.others.ID_image" :count="5" @handleChange="handleChange" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="备注">
            <a-textarea v-model="form.others.remark" allowClear />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
    <a-modal v-model="previewVisible" :footer="null" @cancel="handleCancel">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>

<script>
  import Upload from '../../../components/Upload/index1'
  import { reportAdd, reportEdit } from "@/api/produce";
export default {
  name: "FormModal",
  components: {
    Upload
  },
  model: { prop: "visible", event: "cancel" },
  props: ["visible", "form", "clientsClassificationOptions"],
  data() {
    return {
      previewVisible: false,
      previewImage: '',
      uploadUrl: process.env.VUE_APP_NEW_URL + '/comapi/UploadApi',
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请输入名称", trigger: "blur" },
          { max: 64, message: "超出最大长度 (64)", trigger: "blur" },
        ],
        number: [
          { required: true, message: "请输入编号", trigger: "blur" },
          { max: 32, message: "超出最大长度 (32)", trigger: "blur" },
        ]
      },
      loading: false,
      localVisible: this.visible,
    };
  },
  watch: {
    visible(v) { this.localVisible = v; },
  },
  methods: {
    handleCancel() {
      this.previewVisible = false;
    },
    handleChange(val) {
      this.$set(this.form.others,'ID_image',val);
      this.$forceUpdate();
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? reportEdit : reportAdd;
          let images = (this.form.others.ID_image || [])
            .filter((item) => item.status && item.status === 'done')
            .map((item) => {
              if (item.url) return item.url;
              return item.response.data.file_url;
            });
          let payload = {
            ...this.form,
            others: { ...this.form.others, ID_image: images }
          };
          func(payload)
            .then(() => {
              this.$message.success(this.form.id ? "修改成功" : "新增成功");
              this.$emit(this.form.id ? "update" : "create");
              this.cancel();
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
    },
  },
};
</script>

<style scoped></style>
